
import React from 'react'
import { PerformanceRating } from '@/lib/types'

interface PerformanceBadgeProps {
  rating: PerformanceRating
  value?: string | number
  className?: string
}

export function PerformanceBadge({ rating, value, className = '' }: PerformanceBadgeProps) {
  const ratingClasses = {
    bad: 'performance-bad',
    okay: 'performance-okay', 
    good: 'performance-good',
    great: 'performance-great'
  }

  const ratingLabels = {
    bad: 'Bad',
    okay: 'Okay',
    good: 'Good', 
    great: 'Great'
  }

  return (
    <span className={`performance-badge ${ratingClasses[rating]} ${className}`}>
      {value !== undefined ? value : ratingLabels[rating]}
    </span>
  )
}
